import { Box, CardMedia, Modal, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import AdxInput from 'components/custom/AdxInput'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxButton from 'components/custom/AdxButton'

const EditEmailModal = ({
  candidateName,
  candidateEmail,
  candidateImage,
  editDetails,
  error,
  isLoading,
  profile_type,
  isSuccess,
}) => {
  const { email } = candidateEmail

  const [talentDetails, setTalentDetails] = useState({
    email,
  })

  const emailError =
    Array.isArray(error?.data?.errors?.email) &&
    error?.data?.errors?.email &&
    error?.data?.errors?.email[0]

  const [open, setOpen] = useState(false)

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen)
  }

  const handleUpdate = () => {
    const updatedData = {
      ...(talentDetails.email !== email ? { email: talentDetails.email } : {}),
    }
    editDetails(updatedData)
  }
  useEffect(() => {
    if (isSuccess) {
      handleToggle()
    }
  }, [isSuccess])
  return (
    <React.Fragment>
      {profile_type === 'resume' && (
        <Typography
          onClick={handleToggle}
          sx={{ textDecoration: 'underline', color: 'alternate.main', cursor: 'pointer' }}
        >
          Edit email
        </Typography>
      )}
      <Modal
        open={open}
        onClose={handleToggle}
        sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            backgroundColor: 'white.main',
            borderRadius: '6.5px',
            maxWidth: '650px',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingX: '24px',
              paddingY: '15px',
              borderBottom: '1px solid #E5E5E5',
            }}
          >
            <Typography>Edit email</Typography>
            <CloseIcon onClick={handleToggle} sx={{ cursor: 'pointer' }} />
          </Box>
          <Box sx={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <Typography>
              Update candidate’s email that will be used for interview invitation.
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Typography>Candidate</Typography>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '4.5px',
                  backgroundColor: 'default-background.main',
                  paddingX: '14px',
                  paddingY: '16px',
                  gap: '12px',
                }}
              >
                {candidateImage ? (
                  <CardMedia
                    component="img"
                    sx={{
                      width: '40px',
                      height: '40px',
                      borderRadius: '100%',
                      objectFitL: 'cover',
                    }}
                    src={candidateImage}
                  />
                ) : (
                  <Box
                    sx={{
                      backgroundColor: 'alternate.main',
                      color: 'white.main',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      borderRadius: '100%',
                      height: '40px',
                      width: '40px',
                      textTransform: 'capitalize',
                    }}
                  >
                    {candidateName.charAt(0)}
                  </Box>
                )}
                <Typography>{candidateName}</Typography>
              </Box>
            </Box>
            <AdxInput
              label="Email"
              sxSubLabel={{ color: 'red' }}
              size="standard"
              defaultValue={candidateEmail}
              onChange={(e) =>
                setTalentDetails((prev) => ({
                  email: e.target.value,
                }))
              }
              isErrorShown={error?.data?.errors?.email}
              errorMessage={<AdxErrorMessage>{emailError}</AdxErrorMessage>}
            />
          </Box>
          <Box
            sx={{
              paddingX: '24px',
              paddingTop: '20px',
              paddingBottom: '30px',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              borderTop: '1px solid #E5E5E5',
            }}
          >
            <AdxButton variant={'outlined'} onClick={handleToggle} sx={{ width: '100px' }}>
              Cancel
            </AdxButton>
            <AdxButton
              variant={'contained'}
              isLoading={isLoading}
              onClick={handleUpdate}
              sx={{ width: '200px' }}
            >
              Update
            </AdxButton>
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default EditEmailModal
